import { Link } from 'react-router-dom';
import './legal-pages.css';
import { useEffect } from 'react';

export default function PrivacyPolicy() {
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="legal-page">
      <div className="legal-page-banner">
        <h1 className="legal-page-title">Privacy Policy</h1>
        <div className="legal-page-actions">
          <Link to="/" className="back-pill">Back</Link>
        
        </div>
      </div>

      <p>Your privacy is important to us. This policy explains how DFIVE Coaching collects, uses, and protects your information.</p>

      <h2>1. Information We Collect</h2>
      <p>We may collect your name, email, phone number, and other information when you register or use our services.</p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To provide and improve our services.</li>
        <li>To communicate with you about updates and promotions.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h2>3. Cookies</h2>
      <p>We use cookies to enhance your experience. You can choose to disable cookies through your browser settings.</p>

      <h2>4. Data Sharing</h2>
      <p>We do not sell or share your personal information with third parties except when required by law.</p>

      <h2>5. Data Security</h2>
      <p>We take reasonable measures to protect your personal information from unauthorized access or disclosure.</p>

      <h2>6. Changes to This Policy</h2>
      <p>We may update our Privacy Policy from time to time. Updates will be posted on this page.</p>

      <h2>7. Contact Us</h2>
      <p>
        For questions about this Privacy Policy, please contact us at&nbsp;
        <a href="mailto:coaching@dfivetechnologies.com">coaching@dfivetechnologies.com</a>.
      </p>
    </div>
  );
}
